import { ApiService } from '~/service/service.api';
import { OlfactiveImportDto } from '~/shared/dto/admin/olfactive.dto';
import { OlfactiveFamilyId } from '~/shared/dto/id';
import { Model } from '~/shared/service/service.base';
import { ImportModel } from './model.import';
import { TranslationModel, Translations } from './model.translation';

type OlfactiveRowType = Omit<InstanceType<typeof OlfactiveImportDto>, 'id'> &
	Translations & { olfactiveId: OlfactiveFamilyId };

@Model()
export class OlfactiveImportModel extends ImportModel<OlfactiveImportDto> {
	constructor(
		readonly api: ApiService,
		private readonly tr: TranslationModel,
	) {
		super(OlfactiveImportDto, api.olfactiveImport.bind(api));
	}

	getItemFromRow(row: OlfactiveRowType): OlfactiveImportDto {
		return {
			id: this.parseNumber(row.olfactiveId) as OlfactiveFamilyId,
			name: row.name,
			translations: this.tr.getTranslationsFromRow(row),
		};
	}

	downloadTemplate = () => {
		const example: OlfactiveRowType = {
			olfactiveId: 45,
			name: 'Example Olfactive (en)',
		};
		this.tr.addTranslationsToExample(example);
		this.buildAndDownloadCSV('olfactive-import-template.csv', example);
	};
}
